var _path, _path2, _circle, _circle2, _circle3, _circle4, _path3, _path4, _rect, _rect2, _rect3, _path5, _circle5, _circle6, _circle7, _rect4, _path6, _rect5, _rect6, _rect7, _rect8, _rect9, _rect0, _rect1, _path7, _rect10, _rect11, _circle8, _rect12, _circle9, _rect13, _path8, _path9, _rect14, _rect15, _path0, _circle0, _path1, _path10, _path11, _path12, _circle1, _rect16, _circle10, _path13, _path14, _circle11, _circle12, _path15, _circle13, _circle14;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgRestrictedDomain(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 288,
    height: 263,
    viewBox: "0 0 288 263",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M132.571 35.1505C132.571 35.1505 93.7905 36.8578 73.2466 77.4072C52.7026 117.957 31.4912 105.3 18.9641 141.878C6.43711 178.456 31.6979 220.051 48.6307 224.558C65.5635 229.065 258.976 224.558 258.976 224.558C258.976 224.558 284.53 207.086 286.534 161.705C288.538 116.324 250.457 101.167 234.674 94.7157C218.89 88.2633 194.567 34.1484 132.571 35.1505Z",
    fill: "#F3F5F4"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14 196C40 246 236 252 278 184",
    stroke: "#BBBFBD",
    strokeWidth: 1
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 22,
    cy: 112,
    r: 4.5,
    stroke: "#BBBFBD",
    strokeWidth: 1.2
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 264,
    cy: 70,
    r: 5.5,
    stroke: "#BBBFBD",
    strokeWidth: 1.2
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 270,
    cy: 150,
    r: 3.5,
    fill: "#D9D9D9"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 44,
    cy: 206,
    r: 4,
    fill: "#D9D9D9"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M236 30L243 42H229L236 30Z",
    stroke: "#BBBFBD",
    strokeWidth: 1.2,
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M60 214L65 222H55L60 214Z",
    fill: "#D9D9D9"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 35,
    y: 64,
    width: 156,
    height: 118,
    rx: 10,
    fill: "#D9D9D9",
    fillOpacity: 0.6
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 30,
    y: 58,
    width: 156,
    height: 118,
    rx: 10,
    fill: "#FFFFFF"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 30,
    y: 58,
    width: 156,
    height: 118,
    rx: 10,
    stroke: "#D9D9D9",
    strokeWidth: 1
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M30 68C30 62.4772 34.4772 58 40 58H176C181.523 58 186 62.4772 186 68V78H30V68Z",
    fill: "#0055A4"
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 42,
    cy: 68,
    r: 2.6,
    fill: "#FFFFFF",
    fillOpacity: 0.85
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    cx: 51,
    cy: 68,
    r: 2.6,
    fill: "#FFFFFF",
    fillOpacity: 0.6
  })), _circle7 || (_circle7 = /*#__PURE__*/React.createElement("circle", {
    cx: 60,
    cy: 68,
    r: 2.6,
    fill: "#69AECB"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 40,
    y: 86,
    width: 136,
    height: 16,
    rx: 8,
    fill: "#F3F5F4",
    stroke: "#D9D9D9",
    strokeWidth: 1
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M47.5 93.5V92C47.5 90.6193 48.6193 89.5 50 89.5C51.3807 89.5 52.5 90.6193 52.5 92V93.5",
    stroke: "#FF996A",
    strokeWidth: 1.4,
    strokeLinecap: "round"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 46,
    y: 93,
    width: 8,
    height: 6,
    rx: 1.5,
    fill: "#FF996A"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 60,
    y: 92,
    width: 72,
    height: 4,
    rx: 2,
    fill: "#BBBFBD"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 44,
    y: 116,
    width: 30,
    height: 4,
    rx: 2,
    fill: "#ECEEED"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 44,
    y: 125,
    width: 22,
    height: 4,
    rx: 2,
    fill: "#ECEEED"
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    x: 142,
    y: 116,
    width: 30,
    height: 4,
    rx: 2,
    fill: "#ECEEED"
  })), _rect0 || (_rect0 = /*#__PURE__*/React.createElement("rect", {
    x: 150,
    y: 125,
    width: 22,
    height: 4,
    rx: 2,
    fill: "#ECEEED"
  })), _rect1 || (_rect1 = /*#__PURE__*/React.createElement("rect", {
    x: 44,
    y: 164,
    width: 128,
    height: 4,
    rx: 2,
    fill: "#ECEEED"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M94 128V118C94 110.268 100.268 104 108 104C115.732 104 122 110.268 122 118V128",
    stroke: "#3471BA",
    strokeWidth: 7,
    strokeLinecap: "round"
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    x: 86,
    y: 125,
    width: 44,
    height: 34,
    rx: 7,
    fill: "#0055A4"
  })), _rect11 || (_rect11 = /*#__PURE__*/React.createElement("rect", {
    x: 86,
    y: 125,
    width: 44,
    height: 8,
    rx: 4,
    fill: "#4475B0",
    fillOpacity: 0.5
  })), _circle8 || (_circle8 = /*#__PURE__*/React.createElement("circle", {
    cx: 108,
    cy: 140,
    r: 4.5,
    fill: "#FFFFFF"
  })), _rect12 || (_rect12 = /*#__PURE__*/React.createElement("rect", {
    x: 106,
    y: 142,
    width: 4,
    height: 9,
    rx: 2,
    fill: "#FFFFFF"
  })), _circle9 || (_circle9 = /*#__PURE__*/React.createElement("circle", {
    cx: 182,
    cy: 60,
    r: 13,
    fill: "#FF996A",
    stroke: "#FFFFFF",
    strokeWidth: 3
  })), _rect13 || (_rect13 = /*#__PURE__*/React.createElement("rect", {
    x: 175,
    y: 58,
    width: 14,
    height: 4,
    rx: 2,
    fill: "#FFFFFF"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M211 158H245L243 218H232L228 178L224 218H213L211 158Z",
    fill: "#0055A4"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M228 178L226.5 200",
    stroke: "#3471BA",
    strokeWidth: 1
  })), _rect14 || (_rect14 = /*#__PURE__*/React.createElement("rect", {
    x: 207,
    y: 217,
    width: 18,
    height: 7,
    rx: 3.5,
    fill: "#3F2D1F"
  })), _rect15 || (_rect15 = /*#__PURE__*/React.createElement("rect", {
    x: 231,
    y: 217,
    width: 18,
    height: 7,
    rx: 3.5,
    fill: "#3F2D1F"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M243 117C249 130 250 144 247 155",
    stroke: "#E5BC89",
    strokeWidth: 9,
    strokeLinecap: "round"
  })), _circle0 || (_circle0 = /*#__PURE__*/React.createElement("circle", {
    cx: 246.5,
    cy: 159,
    r: 4.5,
    fill: "#D3AA7D"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M212 113C220 107.5 236 107.5 244 113L247 160H209L212 113Z",
    fill: "#FFD294"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M228 109V160",
    stroke: "#E5BC89",
    strokeWidth: 1
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M214 118L198 109",
    stroke: "#FFD294",
    strokeWidth: 9,
    strokeLinecap: "round"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M198 109L188 102",
    stroke: "#D3AA7D",
    strokeWidth: 7,
    strokeLinecap: "round"
  })), _circle1 || (_circle1 = /*#__PURE__*/React.createElement("circle", {
    cx: 185.5,
    cy: 100.5,
    r: 4.5,
    fill: "#D3AA7D"
  })), _rect16 || (_rect16 = /*#__PURE__*/React.createElement("rect", {
    x: 224,
    y: 101,
    width: 8,
    height: 9,
    rx: 2,
    fill: "#C1966B"
  })), _circle10 || (_circle10 = /*#__PURE__*/React.createElement("circle", {
    cx: 228,
    cy: 91,
    r: 13,
    fill: "#D3AA7D"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M215.2 89.5C214.5 79 221 75 228.5 75C236 75 242 79.5 241 89C238 84 233 82.5 228 83C222 83.5 218 85.5 215.2 89.5Z",
    fill: "#3F2D1F"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M236 77.5C240 76 244 79 243 84C241.5 80.5 239 79 236 77.5Z",
    fill: "#543E2F"
  })), _circle11 || (_circle11 = /*#__PURE__*/React.createElement("circle", {
    cx: 223.5,
    cy: 91.5,
    r: 1.4,
    fill: "#3F2D1F"
  })), _circle12 || (_circle12 = /*#__PURE__*/React.createElement("circle", {
    cx: 232.5,
    cy: 91.5,
    r: 1.4,
    fill: "#3F2D1F"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M224.5 97C226.5 98.8 229.5 98.8 231.5 97",
    stroke: "#3F2D1F",
    strokeWidth: 1.2,
    strokeLinecap: "round"
  })), _circle13 || (_circle13 = /*#__PURE__*/React.createElement("circle", {
    cx: 220.5,
    cy: 95.5,
    r: 1.8,
    fill: "#D37A57",
    fillOpacity: 0.35
  })), _circle14 || (_circle14 = /*#__PURE__*/React.createElement("circle", {
    cx: 235.5,
    cy: 95.5,
    r: 1.8,
    fill: "#D37A57",
    fillOpacity: 0.35
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRestrictedDomain);
export default __webpack_public_path__ + "static/media/restricted_domain.2eff520c40f8c1111538f0d20c0904a4.svg";
export { ForwardRef as ReactComponent };